import {useTranslation} from 'react-i18next';
import {useModal} from '@hooks';
import {Icon} from '@atoms';
import {AllExtraServicesSelectionCard} from '@organisms';
import {P, Span} from '@quarks';
import {getExtrasServicesIcons} from '@utils';
import {ComponentProps} from 'react';
import {TileItem} from '../../TileItem';
import {useExtraServiceUrl, useWorkdayBasedExtraServices} from '@lib/logic';
import {trackEvent} from '@lib/infrastructure';
import {IconNames} from 'mapiq-atoms';

export const AddExtraServicesTile = ({date, ...props}: ComponentProps<typeof TileItem> & {date: string}) => {
  const {t} = useTranslation();
  const {addPages, openModal} = useModal();
  const {highlightedServices, highlightedServicesCount} = useWorkdayBasedExtraServices(date);

  const url = useExtraServiceUrl(highlightedServices.at(0), undefined, date);

  if (highlightedServicesCount === 0) return <></>;

  const isOnlyOneService = highlightedServicesCount === 1;
  const firstService = highlightedServices[0];

  const handleOnClick = () => {
    if (isOnlyOneService) {
      trackEvent('ExtraServices_OpenService', {
        serviceType: firstService.serviceType,
        category: firstService.category,
        buildingId: firstService.buildingId,
      });
      window.open(url, '_blank');
    } else {
      trackEvent('CalendarOverview_ExtraServices__OpenMore');
      addPages([
        <AllExtraServicesSelectionCard
          category="WorkdayBased"
          whitelistedBuidlings={Array.from(new Set(highlightedServices.map((s) => s.buildingId)))}
          locationName={undefined}
          meetingId={undefined}
          selectedDate={date}
        />,
      ]);
      openModal();
    }
  };

  const leftIcon: IconNames = isOnlyOneService ? getExtrasServicesIcons(firstService.serviceType) : 'extras';
  const rightIcon: IconNames = isOnlyOneService ? 'openInBrowser' : 'plus';
  const title = isOnlyOneService ? highlightedServices[0].title : t('AddServices');

  return (
    <TileItem
      data-testid="workday-tile"
      onClick={handleOnClick}
      {...props}>
      <Icon
        className="size-5"
        icon={leftIcon}
      />
      <div>
        <Span fontWeight="bold">{title}</Span>
        {isOnlyOneService && (
          <P
            color="currentColor"
            fontWeight="regular">
            {firstService.description}
          </P>
        )}
      </div>

      <Icon
        className="size-5 justify-self-end"
        icon={rightIcon}
      />
    </TileItem>
  );
};
